import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import PropTypes from 'prop-types';

function DownloadButton({ size, loading, label, handleOnClick, ...other }) {
  return (
    <Button
      onClick={handleOnClick}
      type="primary"
      loading={loading}
      icon={<DownloadOutlined />}
      size={size}
      {...other}
    >
      {label}
    </Button>
  );
}

DownloadButton.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.string,
  handleOnClick: PropTypes.func,
};

DownloadButton.defaultProps = {
  label: 'Generar reporte',
  size: 'middle',
  handleOnClick: () => {
    return;
  },
};

export default DownloadButton;
